module.exports = __webpack_public_path__ + "static/media/zubehoer_symbol.ad9ab2d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/zubehoer_symbol.png
// module id = 388
// module chunks = 0